import Animate from "../partials/animate";

export default class RecipeClipboard {
    constructor($wrapper) {
        this.$wrapper = $wrapper;
        this.$copyToClipBoardTrigger = document.querySelector('[data-copy-to-clipboard]');
        this.$copyToClipBoardSuccessIcon = document.querySelector('[ data-copy-to-clipboard-success-icon]');
        this.$copyToClipBoardSuccessText = document.querySelector('[ data-copy-to-clipboard-success-text]');

        this.copyToClipboard = this.copyToClipboard.bind(this);
        this.$copyToClipBoardTrigger.addEventListener('click', this.copyToClipboard);
    }

    copyToClipboard(e) {
        e.preventDefault();
        // Gather values
        const recipeTitle = this.$copyToClipBoardTrigger.dataset.recipeTitle;
        const url = window.location.href;
        const persons = this.$wrapper.querySelector('[data-number-value]').innerHTML;
        const label = this.$wrapper.querySelector('[data-label-plural]').innerHTML;
        const ingredients = this.$wrapper.querySelectorAll('[data-ingredient-id]');

        // Create text to copy
        let text = recipeTitle + ' (' + url + ')';
        text += '\n' + 'voor ' + persons + ' ' + label;

        // Add all ingredients
        ingredients.forEach(function (ingredient) {

            text += '\n - ';

            if (ingredient.querySelector('[data-amount]')) {
                text += ingredient.querySelector('[data-amount]').innerHTML + ' ';
            }
            if (ingredient.querySelector('[data-unit]')) {
                text += ingredient.querySelector('[data-unit]').innerHTML + ' ';
            }
            if (ingredient.querySelector('[data-title]')) {
                text += ingredient.querySelector('[data-title]').innerHTML + ' ';
            }

        });

        // Copy to clipboard
        navigator.clipboard.writeText(text);

        // Remove classes for visibility
        this.$copyToClipBoardSuccessIcon.classList.remove('d-none');
        (new Animate(this.$copyToClipBoardSuccessIcon));
        this.$copyToClipBoardSuccessText.classList.remove('d-none');
        (new Animate(this.$copyToClipBoardSuccessText));
    }
}
